exports.index = require('rxjs');
exports.operators = require('rxjs/operators');